import { useUserContext, useIdentity, useLogger } from '@vp/ubik-context'
import { getTracking } from '@vp/tracking'
import { EmailComponent, useShowEmailSubscriptionComponent, type Authorization } from '@vp/email-subscription-component'

import { ANALYTICS_METADATA } from './tracking'

export type EmailComponentWrapperProps = {
  authorization: Authorization
}

export const EmailComponentWrapper = (props: EmailComponentWrapperProps) => {
  const { isSignedIn } = useIdentity()
  const userContext = useUserContext()
  const logger = useLogger()

  if (!isSupportedLanguage(userContext.locale)) {
    return null
  }

  const language = userContext.locale
  const country = countryCode(language)
  const tenant = userContext.tenant!

  const placementId = isSignedIn ? 'RCHP' : 'NVHP'

  const { show, isAnonymous, discountInfo } = useShowEmailSubscriptionComponent({
    placementId,
    tenant,
    country,
    language,
    authorization: props.authorization,
    logger,
  })

  return (
    <EmailComponent
      isAnonymous={isAnonymous}
      country={country}
      language={language}
      tenant={tenant}
      tracking={getTracking()}
      show={show}
      discountInfo={discountInfo}
      placementData={ANALYTICS_METADATA}
      authorization={props.authorization}
    />
  )
}

// Quick fix to ignore certain locales for the email component, see the ticket for more details:
// https://vistaprint.atlassian.net/browse/CA-1492
function isSupportedLanguage(language: string) {
  const unsupportedLanguages = ['es-us', 'it-ch']
  return !unsupportedLanguages.includes(language.toLowerCase())
}

const countryCode = (locale: string) => locale.split('-')[1]!.toUpperCase()
